document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const ref = urlParams.get("ref");
  const device = urlParams.get("device");
  const serial = urlParams.get("serial");
  const action = urlParams.get("action");
  const id = urlParams.get("id");

  let isBlurred = false;
  let appOpeningAttempted = false;

  window.addEventListener("blur", () => {
    isBlurred = true;
  });

  window.addEventListener("focus", () => {
    isBlurred = false;
    appStoreFallback();
  });

  function appStoreFallback() {
    if (!appOpeningAttempted) return;
    const installerDiv = document.querySelector(".launch-installer");
    if (installerDiv) {
      installerDiv.classList.add("error");
    }
  }

  function findSerialNumberAndFeatureId() {
    const liElement = document.querySelector(".products li[data-feature-id]");
    if (liElement) {
      const featureId = liElement.getAttribute("data-feature-id");
      const serialNumberElement = liElement.querySelector(".serial-number");
      if (serialNumberElement) {
        const serialNumber = serialNumberElement.textContent.trim();
        return {
          serialNumber: serialNumber,
          featureId: featureId,
        };
      }
    }
    return null;
  }

  async function handleButtonClick(event) {
    const button = event.target;
    const buttonRef = button.getAttribute("data-ref") || ref;
    const buttonDevice = button.getAttribute("data-device") || device;
    const serialAndFeatureId = findSerialNumberAndFeatureId();
    const buttonSerial = button.getAttribute("data-serial") || serial || (serialAndFeatureId ? serialAndFeatureId.serialNumber : null);
    let buttonAction = button.getAttribute("data-action") || action || "install";
    const buttonId = button.getAttribute("data-id") || id || (serialAndFeatureId ? serialAndFeatureId.featureId : null);

    appOpeningAttempted = true;

    try {
      const response = await fetch(garrett.ajaxurl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: new URLSearchParams({
          action: "generate_jwt_token",
          security: garrett.nonce,
        }),
      });

      const result = await response.json();
      if (result.success) {
        const token = result.data.token;
        let appUrl = `garrett://connect/${token}`;

        switch (buttonAction) {
          case "connect":
            if (buttonRef && buttonDevice) {
              const encodedRef = encodeURIComponent(buttonRef);
              appUrl = `garrett://connect/${token}/${encodedRef}/store_connect_device/${buttonDevice}`;
            }
            break;
          case "update":
            appUrl = buttonSerial ? `garrett://install/${token}/${buttonSerial}/update/${buttonId || "latest"}` : `garrett://connect/${token}`;
            break;
          case "install":
            appUrl = buttonSerial ? `garrett://install/${token}/${buttonSerial}/install/${buttonId || "latest"}` : `garrett://connect/${token}`;
            break;
        }

        window.location.href = appUrl;
      } else {
        window.location.href = `garrett://`;
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const buttons = document.querySelectorAll(".launch-app a");
  buttons.forEach((button) => {
    button.addEventListener("click", handleButtonClick);
  });

  if ((ref || action) && buttons.length === 1 && document.querySelector(".launch-installer")) {
    const serialAndFeatureId = findSerialNumberAndFeatureId();
    if (serialAndFeatureId) {
      const button = buttons[0];
      button.setAttribute("data-action", "install");
      button.setAttribute("data-serial", serialAndFeatureId.serialNumber);
      button.setAttribute("data-id", serialAndFeatureId.featureId);
    }
    buttons[0].click();
  }
});
